import * as Sentry from '@sentry/vue'

import { Preferences } from '@capacitor/preferences'
import { Device } from '@capacitor/device'
import { App } from '@capacitor/app'

import { getIMEI } from './headwind'

const STORAGE_KEY_DEVICE_ID = 'bacchus-deviceID'

export const getNetwork = () => navigator.connection.type === 'unknown' ? undefined : navigator.connection.type

export const getDeviceID = async () => {
  return Promise.all([
    Preferences.get({ key: STORAGE_KEY_DEVICE_ID }).then(d => d.value),
    getIMEI(),
    Device.getId().then(({ identifier }) => identifier)
  ])
    .then(([stored, imei, capacitor]) => {
      const deviceID = imei || stored || capacitor || `fallback_${Date.now()}`
      if (deviceID !== stored) Preferences.set({ key: STORAGE_KEY_DEVICE_ID, value: deviceID })
      Sentry.setTag('device.id', deviceID)
      return deviceID
    })
}

export const getDeviceInfo = async () => {
  return Device
    .getInfo()
    .then(info => ({
      model: `${info.manufacturer} ${info.model}`,
      system: `${info.operatingSystem} ${info.osVersion}`,
      webview: info.webViewVersion
    }))
    .catch(() => null)
}

export const getAppInfo = async () => {
  return App.getInfo()
    .then(info => {
      Sentry.setTag('build', info.version || '-')
      return {
        appURI: info.id,
        appBuild: info.build,
        appVersion: info.version
      }
    }, err => {
      Sentry.captureException(err)
    })
    .catch(() => null)
}

export const getBattery = async () => {
  return Device
    .getBatteryInfo()
    .then(res => Object.freeze({
      timestamp: Date.now(),
      level: Math.round(res.batteryLevel * 100),
      isCharging: res.isCharging
    }))
    .catch(err => {
      Sentry.captureException(err)
      return null
    })
}
